import React, { useEffect, useState } from 'react'
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthProvider';
import { CircularProgress } from '@mui/material'
import styles from '../../pages/ApplicationReview/ApplicationReview.module.css'
import Login from '../../pages/Login/Login';
import { useAuthCheck } from '../../hooks/useAuthCheck';


const ProtectedRoutes = ({ children }) => {
    const isAuthenticated = useAuthCheck();
    if (isAuthenticated == null) return null;
    return isAuthenticated ? children : <Navigate to="/" replace />;
}

export default ProtectedRoutes